import AntdLink from "antd/es/typography/Link";

const Link = AntdLink;

export { Link };
